


import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { motion } from "framer-motion";

export default function EnquiryModal({
  formData,
  handleFormChange,
  handleSubmit,
  isSubmitting,
  setModalVisible,
}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => setModalVisible(false), 400);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 60 }}
        transition={{ duration: 0.4 }}
        className="bg-white dark:bg-slate-800 max-w-4xl w-full rounded-2xl shadow-xl overflow-y-auto max-h-[90vh] relative transition-colors duration-300"
      >
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white text-2xl z-10 transition-colors duration-300"
        >
          ×
        </button>

        <section className="py-10 px-6 sm:px-10">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-indigo-700 dark:text-indigo-400">Enquiry Form</h2>
            <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">We usually respond within 24 hours</p>
          </div>

          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleFormChange}
              className="border border-gray-300 p-2 rounded-md"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleFormChange}
              className="border border-gray-300 p-2 rounded-md"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone (10 digits)"
              value={formData.phone}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                if (onlyNums.length <= 10) {
                  handleFormChange({ target: { name: "phone", value: onlyNums } });
                }
              }}
              className="border border-gray-300 p-2 rounded-md"
              maxLength="10"
              required
            />
            <select
              name="inquiryType"
              value={formData.inquiryType}
              onChange={handleFormChange}
              className="border border-gray-300 p-2 rounded-md"
              required
            >
              <option value="">Select Enquiry Type</option>
              <option value="Admin Enquiry">Admin Enquiry</option>
              <option value="General Enquiry">General Enquiry</option>
              <option value="Support Enquiry">Support Enquiry</option>
              <option value="Other">Other</option>
            </select>
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleFormChange}
              className="border border-gray-300 p-2 rounded-md col-span-1 md:col-span-2"
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleFormChange}
              rows="4"
              className="border border-gray-300 p-2 rounded-md col-span-1 md:col-span-2"
              required
            ></textarea>
            <button
              type="submit"
              className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-md flex items-center justify-center gap-2 col-span-1 md:col-span-2"
              disabled={isSubmitting}
            >
              <Send size={18} />
              {isSubmitting ? "Sending..." : "Submit Enquiry"}
            </button>
          </form>
        </section>
      </motion.div>
    </div>
  );
}
